import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Tooltip from "../Common/Tooltip";
import { useForm } from "react-hook-form";
import { languageServices } from "../../Services/language.service";
import ResultModal from "../Common/ResultModal";

const AddResourcesModal = ({ show, handleHide, languageId }) => {
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, setValue } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });
  const [serverError, setServerError] = useState(null);
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const handleClose = () => {
    setModal({ show: false });
  };

  const handleSave = (data) => {
    handleHide();
    languageServices
      .createTranslation({
        languageId: (languageId),
        key: data.key,
        value: data.value,
      })
      .then((res) => {
        if (res.status === 200) {
          handleHide();
          setModal({
            show: true,
            title: translator("Translation-SuccessModal-Title"),
            text: translator("Translation-SuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setServerError(res.data.errors[0].value);
        }
      })
      .catch((err) => {
        setServerError(err);
      });
  };

  return (
    <>
      <Modal show={show} onHide={handleHide} centered>
        <Modal.Header>
          <Modal.Title>{translator("Language-CreateTranslation")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         
          <div className="form-group">
              <label>{translator("Language-CreateTranslation-Key")}</label>{" "}
              <Tooltip text={translator("Message-InputTitle-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  maxLength: 200,
                })}
                name="key"
                
              />
              {errors.title && errors.title.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.title && errors.title.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength200")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Language-CreateTranslation-Value")}</label>{" "}
              <Tooltip text={translator("Message-CreateTranslation-Msg")} />
               <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  maxLength: 4000,
                })}
                name="value"
                
              />
              {errors.text && errors.text.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.text && errors.text.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength4000")}
                </p>
              )}
            </div>
          {serverError && <p className="text-danger">{serverError}</p>}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={handleHide}
          >
            {translator("General-Close")}
          </button>
          <button
            onClick={handleSubmit(handleSave)}
            type="button"
            className="btn btn-primary"
          >
            {translator("Btn-Save")}
          </button>
        </Modal.Footer>
      </Modal>

      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </>
  );
};

export default AddResourcesModal;
